module.exports = __webpack_public_path__ + "static/dd-3591bebfe9baef8fc3701395722ff522.jpg";